import { computed, defineComponent, h } from 'vue';
import { SettingsEntrySingleLine } from '@features/user-settings';
import { CurvatureCombIcon } from '../curvature-comb-icon';
import { FormRange } from '@components/form';
import { img } from '@phi/components';
import {
    curvature_comb_scaling_factor,
    set_curvature_comb_scaling_factor,
} from '@features/curvature-combs';

const linear_to_exp_scaling_factor = (x: number) => Math.pow(10, x-3);
const exp_to_linear_scaling_factor = (x: number) => Math.log10(x) + 3;

export const CurvatureCombScaling = defineComponent({
    setup() {
        const linearised_scaling_factor = computed(() => exp_to_linear_scaling_factor(curvature_comb_scaling_factor.value));

        function on_update(x: number) {
            set_curvature_comb_scaling_factor(linear_to_exp_scaling_factor(x));
        }

        return () => SettingsEntrySingleLine(
            'Curvature comb scaling factor',

            undefined,

            img(CurvatureCombIcon, 'Curvature comb scaling factor'),

            h(FormRange, {
                min: 1,
                max: 5,
                from: 3,
                step: 0.125,
                percentage: true,
                value: linearised_scaling_factor.value,
                'onUpdate:value': on_update,
            }),
        );
    },
});
